import { toast } from "react-toastify";

export const copyToClipboard = async (text, content, ) => {
    try {
      toast.dismiss();
      await navigator.clipboard.writeText(content);
      toast.success(`${text} copiado!`, {
        autoClose: 1500,
        theme: "light",
      });
    } catch (error) {
      console.error("Falha ao copiar:", content);
      toast.error(`Falha ao copiar ${text}`, {
        autoClose: 1500,
        theme: "light",
      });
    };
  }